import React from "react";
import { newContextComponents } from "@drizzle/react-components";
import WithdrawTokens from "./WithdrawTokens";
import Refund from "./Refund";
import { Trans } from 'react-i18next';

import { Web3StatusContext } from "../contexts/Web3StatusContext";

const { AccountData, ContractData, ContractForm } = newContextComponents;

class WithdrawOrRefund extends React.Component {
  static contextType = Web3StatusContext;
  lastBlock = 0;

  state = { refundsEnabledDataKey: null,
    finalizedDataKey: null,
    hasClosed: null,
    now: null
  };

  componentDidMount() {
    const { drizzle } = this.props;
    const contract = drizzle.contracts.GAMEFORESTSale;
  
    // let drizzle know we want to watch the `myString` method
    const refundsEnabledDataKey = contract.methods["refundsEnabled"].cacheCall();
    const finalizedDataKey = contract.methods["finalized"].cacheCall();
    // save the `dataKey` to local component state for later reference
    this.setState({ refundsEnabledDataKey, finalizedDataKey });
  }

  componentDidUpdate() {
    if(this.lastBlock == this.context.blockNumber)
      return;

    const { drizzle } = this.props;
    const contract = drizzle.contracts.GAMEFORESTSale;

    contract.methods.hasClosed().call().then(function(result) {
      this.setState({hasClosed: result});
    }.bind(this));

    this.lastBlock = this.context.blockNumber;
  }

  // destructure drizzle and drizzleState from props
  render() {
    // get the contract state from drizzleState
    const { GAMEFORESTSale } = this.props.drizzleState.contracts;

    // using the saved `dataKey`, get the variable we're interested in
    const refundsEnabledFromContract =
      GAMEFORESTSale["refundsEnabled"][this.state.refundsEnabledDataKey];

    const finalizedFromContract =
      GAMEFORESTSale["finalized"][this.state.finalizedDataKey];

    const hasClosed = this.state.hasClosed;
    
    var renderValue = <span></span>;
    if(refundsEnabledFromContract !== undefined &&
      finalizedFromContract !== undefined &&
      hasClosed !== null) {
        if(hasClosed) {
          if(!refundsEnabledFromContract.value) {
            if(!finalizedFromContract.value) {
              renderValue = <span><Trans>withdraw_or_refund.waiting_finalization</Trans></span>;
            }
            else {
              renderValue = <WithdrawTokens
                drizzle={this.props.drizzle}
                drizzleState={this.props.drizzleState}>
                
                </WithdrawTokens>;
            }
          }
          else {
            if(!finalizedFromContract.value) {
              renderValue =
              <span>
                <b>
                <Trans>withdraw_or_refund.softcap_not_met</Trans>
                </b><br/>
                <Trans>withdraw_or_refund.waiting_finalization_refund</Trans>
              </span>;
            }
            else {
              renderValue = <Refund
                  drizzle={this.props.drizzle}
                  drizzleState={this.props.drizzleState}
                  >

                </Refund>;
            }
          }
        }
        else {

        }
      return renderValue;
    }
    
    return '--';
  }
};

export default WithdrawOrRefund;